const $ = jQuery;
import Swal from "sweetalert2";

export default class OnboardingFlow {
  constructor() {
    this.locked_messages = {
      mediakit: "Please complete at least 3 action items in My Game Plan first",
      calculator: "Please complete your Media Kit first",
      templates_before_calculator: "Please complete your Media Kit first",
      templates_after_calculator:
        "Please view the \u0060How to price yourself with confidence using the Rate Calculator\u00B4 training first",
      find_a_contact:
        "Please reach level silver first in My Game Plan. Join at least two opt-in platforms and apply for 5 campaigns.",
    };
  }

  fireWarningSwal = (message) => {
    Swal.fire({
      title: "",
      width: "26em",
      customClass: {
        title: "swal2-title gc-alert-text",
        confirmButton: "the-btn third-btn",
        htmlContainer: "swal2-html-container gc-warning-text",
      },
      html: message,
      icon: "warning",
    });
  };

  bindEvents = () => {
    $(".uv-user-menu-container div ul li.disabled").on("click", (event) => {
      const element = event.target;
      for (const key in this.locked_messages) {
        if (element.classList.contains(`templates-unlockable-menu`)) {
          // handle template cases here
          let swalMessage = this.locked_messages.templates_after_calculator;
          if (
            event.target.parentNode
              .querySelector(".calculator-unlockable-menu")
              .classList.contains("disabled")
          ) {
            swalMessage = this.locked_messages.templates_before_calculator;
          }
          this.fireWarningSwal(swalMessage);
          break; // stop checking further keys
        } else if (element.classList.contains(`${key}-unlockable-menu`)) {
          this.fireWarningSwal(this.locked_messages[key]);
          break; // stop checking further keys
        }
      }
    });
  };

  unlockHowtoPriceSelf = () => {
    this.unlockCategories(
      [
        "Opt-In Platforms",
      ],
      () => {
        this.unlockMenu("templates", () => {
          $("div#user-menu-wrapper ul li.templates-unlockable-menu")
            .first()
            .removeClass("disabled");
        });
      }
    );
  };

  unlockMenu = (menuName, successCallback) => {
    $.ajax({
      url: CSWP.ajax_url,
      method: "POST",
      dataType: "json",
      data: {
        action: "cs_unlock_menu",
        menu_name: menuName,
        _ajax_nonce: CSWP.nonce,
      },
      success: (response) => {
        if (response.success) {
          successCallback();
        } else {
          console.log("Error unlocking menu: internal error");
        }
      },
      error: (jqXHR, textStatus, errorThrown) => {
        console.log(`Error unlocking menu: ${errorThrown}`);
      },
    });
  };

  unlockCategories = (categoryList, successCallback) => {
    $.ajax({
      url: CSWP.ajax_url,
      method: "POST",
      dataType: "json",
      data: {
        action: "cs_unlock_mpg_categories",
        category_names: categoryList,
        _ajax_nonce: CSWP.nonce,
      },
      success: (response) => {
        if (response.success) {
          successCallback();
        } else {
          console.log("Error unlocking categories: internal error");
        }
      },
      error: (jqXHR, textStatus, errorThrown) => {
        console.log(`Error unlocking Category: ${errorThrown}`);
      },
    });
  };
}
